/* global OSpy */
import upload from '../upload';
import Util from 'utils';
import config from 'config/Config';
import dayjs from 'dayjs';
import { zipSync, strToU8 } from 'fflate';

const PAGESPY_FLAG_KEY = 'pagespyEnabled';
const isDevMode = process.env.NODE_ENV === 'development';
const isPagespyDebugEnabled = localStorage.getItem(PAGESPY_FLAG_KEY) === 'true';
const shouldInitPagespy = isPagespyDebugEnabled || !isDevMode;

if (shouldInitPagespy) {
  const $oSpy = new OSpy.default({ lang: 'zh' });
  const warn = (...args) => {
    if (isPagespyDebugEnabled) {
      console.warn(...args);
    }
  };

  // 上传状态标记，避免重复触发上传
  let isUploading = false;

  // 记录上次容量超限触发时间
  let lastCapacityExceededTime = 0;

  // 记录上次容量超限触

  // 封装下载上报函数
  const triggerDownload = () => {
    // if (process.env.NODE_ENV !== 'production') {
    //   return;
    // }
    // 如果正在上传中，则跳过本次触发
    if (isUploading) {
      warn('日志上传中，跳过本次触发');
      return;
    }

    const userInfo = Util.getLocalCache(config.localStorageKeys.member_userInfo) || {};
    if (!userInfo.cardCode) {
      warn('未找到 cardCode，跳过上传');
      return;
    }

    // 立即设置标志位，防止并发调用
    isUploading = true;
    warn('设置上传标志位');

    // 调用 download，如果失败则重置标志位
    $oSpy.$harbor.download().catch((err) => {
      console.error('下载触发失败:', err);
      isUploading = false;
    });
  };

  $oSpy.$harbor.$harborConfig.onCapacityExceeded = () => {
    // 文件体积超限时调用上报
    const now = Date.now();
    const timeSinceLastTrigger = now - lastCapacityExceededTime;

    // 如果距离上次触发小于20秒，则跳过
    if (timeSinceLastTrigger < 20 * 1000) {
      warn(`容量超限，但距离上次触发仅 ${Math.floor(timeSinceLastTrigger / 1000)} 秒，跳过上传`);
      return;
    }

    warn('容量超限，触发上传');
    lastCapacityExceededTime = now;
    triggerDownload();
  };

  // 定时上报：每隔2分钟调用一次
  setInterval(
    () => {
      warn('定时触发上传');
      triggerDownload();
    },
    2 * 60 * 1000
  ); // 2分钟

  $oSpy.$harbor.$harborConfig.onCustomDownload = async (data) => {
    warn('开始上传，数据大小:', data.size);

    try {
      const userInfo = Util.getLocalCache(config.localStorageKeys.member_userInfo) || {};
      const cardCode = userInfo.cardCode;

      if (!cardCode) {
        warn('未找到 cardCode，跳过上传');
        isUploading = false;
        return;
      }

      const now = dayjs();
      const rawFileName = `${now.format('HHmmss')}.json`;
      const fileName = `${rawFileName}.zip`;
      let rawBytes;
      if (data instanceof Blob) {
        rawBytes = new Uint8Array(await data.arrayBuffer());
      } else if (data instanceof Uint8Array) {
        rawBytes = data;
      } else if (typeof data === 'string') {
        rawBytes = strToU8(data);
      } else {
        rawBytes = strToU8(JSON.stringify(data || {}));
      }
      const zipped = zipSync({ [rawFileName]: rawBytes }, { level: 6 });
      const zipBlob = new Blob([zipped], { type: 'application/zip' });
      const file = new File([zipBlob], fileName, { type: 'application/zip' });

      warn('压缩后大小:', file.size);

      // 使用 async/await 确保上传完成
      const uploadCfg = await upload.getUploadCfg(file, cardCode);
      await upload.postObject2OSS(uploadCfg);

      warn('日志上传成功');

      // 上传成功后手动清空缓存，从0开始累积
      $oSpy.$harbor.clearAndNotify();
      warn('缓存已清空');
    } catch (e) {
      console.error('日志上传失败:', e);
    } finally {
      // 重置标志位，允许下次上传
      isUploading = false;
      warn('重置上传标志位');
    }
  };

  window.$oSpy = $oSpy;
} else {
  window.$oSpy = null;
}



// WEBPACK FOOTER //
// ./src/utils/pagespy/index.js